// /eventos/:id/comprar — Flujo de compra interno (CheckoutProvider dispatcher)
// FASE 1: stripe reutiliza PurchaseDrawer (modo embebido). fourvenues/whan muestran stub.
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { COLORS } from './designSystem';
import { EventsService } from './EventsService';
import PurchaseDrawer from '../components/PurchaseDrawer';
import { useSafeBack } from './components';

export default function CheckoutPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const goBack = useSafeBack(`/eventos/${id}`);
  const initialTicketId = params.get('ticket_id') ? Number(params.get('ticket_id')) : null;
  const initialQuantity = params.get('qty') ? Math.max(1, Number(params.get('qty'))) : 1;
  const [event, setEvent] = useState(null);

  useEffect(() => { (async () => setEvent(await EventsService.getEvent(id)))(); }, [id]);

  if (!event) return (<div className="min-h-screen p-5" style={{ backgroundColor: COLORS.bg, color: COLORS.text }}>Cargando…</div>);

  // Provider dispatcher
  if (event.provider === 'fourvenues' || event.provider === 'whan') {
    return (
      <div className="min-h-screen" style={{ backgroundColor: COLORS.bg }}>
        <div className="mx-auto max-w-[430px] p-5">
          <button onClick={goBack} className="w-10 h-10 mb-4 flex items-center justify-center rounded-full" style={{ backgroundColor: COLORS.surface }}><ChevronLeft size={22} color={COLORS.text} /></button>
          <h1 className="text-white text-xl font-extrabold mb-3">Compra no disponible aún</h1>
          <p className="text-sm" style={{ color: COLORS.textMuted }}>Este evento se compra vía <strong>{event.provider}</strong>, que aún no está conectado. Vuelve pronto — en cuanto esté conectado, podrás comprar sin salir de Clubbers.</p>
        </div>
      </div>
    );
  }

  // Default: stripe — reuse existing PurchaseDrawer. Adapt event shape for compatibility.
  const legacy = {
    id: event.id, name: event.name, venue: event.venue, price: event.price,
    image: event.image || event.imagen_url, location: event.location, day: event.day,
    description: event.description, slug: event.slug, venue_id: event.venue_id,
  };
  return (
    <PurchaseDrawer
      event={legacy}
      isOpen={true}
      onClose={goBack}
      initialTicketId={initialTicketId}
      initialQuantity={initialQuantity}
      skipTicketStep={!!initialTicketId}
    />
  );
}
